import React, {Component} from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import LocationSearching from '@material-ui/icons/LocationSearching';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import TextField from '@material-ui/core/TextField';



const drawerWidth = 240;
const styles = theme =>({
  root: {
    display: 'flex',
  },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
          background: '#2f85bc'
        })
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 20,
        color:"white"
    },
    hide: {
        display: 'none',
    },
    userName: {
        marginRight: 5,
        color:"white"
    }
});

class AppBarCustom extends Component {

    constructor(props){
        super(props);
        
        this.state = {
            anchorEL: null,
            anchorElLoc: null,
            locIndoor: false,
            locHistorical: false
        };
    }

    render(){
        const {classes, history, open, userName,user, handleDrawerOpen, logout} = this.props;
        const {anchorEl, anchorElLoc, locIndoor, locHistorical} = this.state;
        const openMenu = Boolean(anchorEl);
        const openMenuLoc = Boolean(anchorElLoc);


        let colorI;
        
        if(user.IdUsuario==453){
          colorI='#a02042';
        }else if(user.IdUsuario==452){
          colorI='#06B6D4'
        }else if(user.IdUsuario==458){
          colorI='#F6025C'
        }else if(user.IdUsuario==451){
          colorI='#731228'
        }else if(user.IdUsuario==448){
          colorI='#41AB34'
        }else if(user.IdUsuario==450){
          colorI='#318e25'
        }
        else{
          colorI='#a02042';
        }

        return(
        <div className={classes.root}>
          <CssBaseline/>
          <AppBar position="fixed" style={{height: 62, background: colorI}}>
           
            <Toolbar disableGutters={!open}>
            

              <IconButton color="textPrimary"
                aria-label="Open drawer"
                onClick={handleDrawerOpen}
                className={classNames(classes.menuButton, open && classes.hide)}>
                <MenuIcon />
              </IconButton>
            

         

              
              <div style={{width:'75%',marginRight:40}}>
              
              </div> 
             
            <div align="right" style={{alignItems:'center',position:'absolute',right:20,display:'flex'}}>
            <RadioButtonCheckedIcon style={{color:'#118811'}} />&nbsp; &nbsp; 
            <Typography variant="h6"
                color="white"
                className={classes.userName}
                style={{marginRight:20}}
                >
               {userName}
            
              </Typography>
              v1.1.10
 <IconButton style={{outline: 'none',color:'white'}}
                  aria-owns={openMenu ? 'menu-appbar' : undefined}
                  aria-haspopup="true"
                  align="right"
                  onClick={(event) => this.setState({ anchorEl: event.currentTarget })}
                  color="white">
                    
                  <AccountCircle />
                </IconButton>


           
          
          

                <Menu id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={openMenu}
                  onClose={(event) => this.setState({ anchorEl: null })}>
       
                  <MenuItem onClick={logout}>CERRAR SESIÓN</MenuItem>
                </Menu>

               
              </div>

      
                

            </Toolbar>
          </AppBar>
        </div>
        );
    }
}

AppBarCustom.propTypes = {
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    handleDrawerOpen: PropTypes.func,
    logout: PropTypes.func,
    open: PropTypes.bool,
    userName: PropTypes.string
};
export default withRouter(withStyles(styles, { withTheme: true })(AppBarCustom));